// extracted by mini-css-extract-plugin
export var checkbox = "_4x-0";
export var circle = "_4x-3";
export var horizontalContainer = "_4x-7";
export var sm = "_4x-5";
export var switch0 = "_4x-2";
export var switchDisabled = "_4x-8";
export var switchEnabled = "_4x-1";
export var textSwitchContainer = "_4x-9";
export var textSwitchOption = "_4x-a";
export var textSwitchOptionSelected = "_4x-b";
export var verticalContainer = "_4x-6";
export var xs = "_4x-4";